<template>
  <section class="content-current-tab">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="content-current">
      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">

            <input type="text" v-model="reserveData.voucherNumber" />
            <span class="highlight"></span><span class="bar"></span>
            <label class="lbl-report"> شماره واچر</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi inputContainer">
            <input type="text" v-model="reserveData.reserveNumber" />
            <span class="highlight"></span><span class="bar"></span>
            <label class="lbl-report">شماره رزرو</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="btn-search">
            <button type="submit" v-if="!isLoading" class="btn btn-primary" @click.prevent="search()">
              جستجو
            </button>
            <button v-else type="submit" class="btn btn-primary"
              style="background-color: #ccdbd2; height: 45px; font-size: 14px">
              جستجو
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-md-12 loading" v-if="isLoading">
      <PdkLoadingBar type="ripple" />
    </div>

    <div class="row content-current" v-if="!isLoading && hasResult">
      <div class="col-md-12 col-xs-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="box-title">
              <i class="fa fa-info-circle fa-fw" style="color: #178a00"></i><label>اطلاعات رزرو</label>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <label>نام و نام خانوادگی: </label>
                {{ booking.customerFirstName + " " + booking.customerLastName }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>شماره واچر: </label>
                {{ booking.voucherNumber }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>شماره رزرو: </label>
                {{ booking.reserveNumber }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-sm-4">
                <label>فروشنده: </label>
                {{ booking.sourceName }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>تاریخ صدور : </label>
                {{ booking.createdDate | persianDate("jYYYY/jMM/jDD") }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>تاریخ ورود : </label>
                {{ booking.arrivalDate | persianDate("jYYYY/jMM/jDD") }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-sm-4">
                <label>قیمت: </label>
                {{ booking.paiedAmount | numFormat | rial }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>مبلغ پرداخت شده: </label>
                {{ booking.paiedAmount | numFormat | rial }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>تخفیف / کمیسیون مشتری : </label>
                {{ booking.commission }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <label>تعداد بزرگسال: </label>
                {{ booking.adult }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>تعداد کودک: </label>
                {{ booking.child }}
              </div>
              <div class="col-md-4 col-sm-4">
                <label>تعداد نوزاد: </label>
                {{ booking.infant }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xs-12">
        <div class="box-body">
          <hr />
          <div class="row">
            <div class="col-md-4 col-sm-4">

              <div class="select">
                <select class="select-text" v-model="cancelreasonid">
                  <option v-for="item in cancelReasonList" :value="item.id" :key="item.id">
                    {{ item.title }}
                  </option>
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <label class="select-label validation-color"> * دلیل کنسلی</label>
                <p class="text-danger" v-if="!$v.cancelreasonid.required && $v.cancelreasonid.$dirty">
                  لطفا دلیل کنسلی را وارد نمائید
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 group_mdi">
              <currency-input v-model="totalPaied" :disabled="!reserveData.isAdmin" @blur="$v.totalPaied.$touch()"
                :class="{ invalid: $v.totalPaied.$error }" currency="IRR" locale="fa" />
              <label>مبلغ قابل بازگشت: </label>
              <span class="highlight"></span>
              <span class="bar"></span>
              <p class="text-danger" v-if="!$v.totalPaied.maxValue && $v.totalPaied.$dirty">
                مبلغ بازگشتی از مبلغ پرداخت شده بیشتر است !!!
              </p>
            </div>
            <div class="col-md-4 col-sm-4 group_mdi">
              <label>جریمه : </label>

              <input type="text" v-model="totalNoShow" disabled />
              <span class="highlight"></span>
              <span class="bar"></span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12">
              <textarea type="text" class="style-textarea" rows="2" v-model="description" placeholder="توضیحات"
                style="margin-top:30px;" />
              <span class="highlight"></span>
              <span class="bar"></span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="btn-search">
              <button type="submit" class="btn-profile" @click="cancel" :disabled="$v.$invalid"
                :class="{ disabledBtn: $v.$invalid }">
                کنسل
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PDKAlertModal :buttonObject="cancelTitle" v-if="showAlert" @btnAction="closeAlert">
      <div style="text-align: center" slot="body">
        <div class="swal-icon"><span class="info">i </span></div>
        <h4 style="margin-top: 10px">ابطال این رزرو امکان پذیر نیست.</h4>
      </div>
    </PDKAlertModal>
  </section>
</template>
<script>
import store from "../../../views/tourism/store/index";
import PDKAlertModal from "@/components/PDKAlertModal";
import PdkLoadingBar from "../../../components/loading/pdkLoadingBar.vue";
import { required, maxValue } from "vuelidate/lib/validators";

export default {
  store,
  components: { PDKAlertModal, PdkLoadingBar },

  data() {
    return {
      reserveData: {
        reserveNumber: null,
        voucherNumber: null,
        sourceProfileId: "",
        isAdmin: false,
      },
      cancelModel: {
        bookingId: 0,
        cancelreasonid: null,
        description: "",
        repaidRefrenceCode: "",
        repaidType: 1,
        sourceId: "",
        totalAmount: "",
        totalRepaid: "",
        canceluserId: "",
      },
      totalNoShow: 0,
      totalPaied: 0,
      cancelReasonList: [],
      cancelreasonid: "",
      description: "",
      updateCreditUrl: "https://api.dariushgroup.com/Hotel/V1/",
      booking: {},
      showAlert: false,
      isLoading: false,
      hasResult: false,
      cancelTitle: {
        title: "بستن",
      },
      tourismType: 1,
    };
  },
  validations() {
    return {
      cancelreasonid: { required },
      totalPaied: { maxValue: maxValue(this.booking.paiedAmount) },
    };
  },
  mounted() {
    this.getTourismType();
  },
  methods: {
    getTourismType() {
      const tourismType = this.$route.params.tourismType;
      if (tourismType === "fastTrack") this.tourismType = 2;
      else this.tourismType = 1;
    },
    async search() {
      this.isLoading = true;
      //check shakeri UserId
      if (
        localStorage.getItem("UserId") ===
        "E03BD1E5-449B-4F99-B3D6-1658E2B6B3CA"
      ) {
        this.reserveData.isAdmin = true;
      }

      this.reserveData.sourceProfileId =
        localStorage.getItem("SourceProfileId");

      if (this.tourismType === 2) this.searchInFastTrack();
      else this.searchInDolphin();
    },
    async searchInFastTrack() {
      const res = await this.$store.dispatch(
        "getBookingListForCancel",
        this.reserveData
      );

      if (res != undefined) {
        this.getCancelreasonInFastTrack();

        if (res.data.data.length > 0) {
          this.booking = res.data.data[0];
          this.totalNoShow = this.booking.totalNoShow;
          this.totalPaied = this.booking.totalPaied;
          this.hasResult = true;
          this.showAlert = false;
        } else {
          this.hasResult = false;
          this.showAlert = true;
        }
      } else {
        this.hasResult = false;
        this.showAlert = true;
      }
      this.isLoading = false;
    },
    async searchInDolphin() {
      const res = await this.$store.dispatch(
        "getBookingListForCancelDolphin",
        this.reserveData
      );

      if (res != undefined) {
        this.getCancelreasonInDolphin();

        if (res.data.data.length > 0) {
          this.booking = res.data.data[0];
          this.totalNoShow = this.booking.totalNoShow;
          this.totalPaied = this.booking.totalPaied;
          this.hasResult = true;
          this.showAlert = false;
        } else {
          this.hasResult = false;
          this.showAlert = true;
        }
      } else {
        this.hasResult = false;
        this.showAlert = true;
      }
      this.isLoading = false;
    },
    async getCancelreasonInFastTrack() {
      const res = await this.$store.dispatch("getCancelreason");
      if (res.status == 200) {
        this.cancelReasonList = res.data.data;
      }
    },
    async getCancelreasonInDolphin() {
      const res = await this.$store.dispatch("getCancelreasonDolphin");
      if (res.data.data.isSuccess == true) {
        this.cancelReasonList = res.data.data;
      }
    },
    async cancel() {
      this.cancelModel = {
        sourceId: this.booking.sourceId,
        userId: 0,
        bookingId: this.booking.bookingId,
        cancelreasonid: this.cancelreasonid,
        description: this.description,
        repaidRefrenceCode: "",
        repaidType: 1,
        isNoshowCharged: false,
        noshowRate: 0,
        isRefunded: false,
        cancelConfirmation: "",
        totalAmount: this.booking.paiedAmount,
        totalRepaid: this.totalPaied,
        updateCreditUrl: this.updateCreditUrl,
        isAdmin: this.reserveData.isAdmin,
      };
      this.isLoading = true;
      if (this.tourismType === 2) this.cancelInFastTrack();
      else this.cancelInDolphin();
    },
    async cancelInFastTrack() {
      const res = await this.$store.dispatch("bookingCancel", this.cancelModel);
      if (res.data.data[0].isSuccess) {
        if (res.data.data[0].message == "Booking cancel was successful") {
          this.$store.dispatch(
            "getDepositInCrs",
            localStorage.getItem("SourceIdInReport")
          );
          // alert("کنسل با موفقیت انجام پذیرفت");
          this.$toast.success("کنسل با موفقیت انجام پذیرفت", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      } else {
        // alert(res.data.data[0].message);
        this.$toast.error(res.data.data[0].message, {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });

      }
      this.isLoading = false;
      this.hasResult = false;
    },
    async cancelInDolphin() {
      const res = await this.$store.dispatch(
        "bookingCancelDolphin",
        this.cancelModel
      );
      if (res.status == 200) {
        if (res.data.data[0].message == "Booking cancel was successful") {
          this.$store.dispatch(
            "getDepositInCrs",
            localStorage.getItem("SourceIdInReport")
          );
          alert("کنسل با موفقیت انجام پذیرفت");
          this.isLoading = false;
        }
      }
    },
    closeAlert() {
      this.showAlert = !this.showAlert;
    },
  },
};
</script>
<style scoped>
.btn-search {
  margin-top: 28px;
  text-align: center;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.swal-icon {
  width: 80px;
  height: 80px;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  margin: 20px auto;
  border-color: #659aaf;
}

.info {
  display: inline-block;
  color: #659aaf;
  font-size: 38px;
  width: 20px;
  height: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}

.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}

group_mdi .bar {
  width: 55%;
}
</style>
